<ng-container *ngFor="let rec of templateList;">
  <div class="row mt-5 mr-3">
    <div class="col-sm-4" *ngFor="let t of rec;">
      <div class="tiles">
        <div class="row mt-2">
          <div class="col-md-2">
            <img style="width: 100%;" src="assets/img/mealimg.png" />
          </div>
          <div class="col-md-10">
            <div class="row" style="margin-left: 0px;">
              <div class="col-md-12 noPad labels"><label>{{t.mealPlanName}}</label></div>
            </div>
            <div class="col-md-12 noPad labelContent">
              <label>Date of Creation: {{formatCardDate(t.createdDateTime)}} &nbsp;&nbsp; </label>
            </div>
          </div>
        </div>
        <div class="row mt-4 cardActionRow">
          <div class="col-md-12">
            <div class="row align-items-center">
              <div class="col"></div>
              <div class="col-auto cardActionBtns cardActionBtnsRight">
                <button class="btn btnDelete btnLabel1" (click)="openDeleteConfirm(t)">Delete</button>
                <button class="btn btnToDraft btnLabel1" (click)="importForMember(t)">Import To</button>
                <button class="btn btnView btnLabel" (click)="viewTemplate(t)">View</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<div class="row mt-4" *ngIf="templates.length === 0">
  No Record Found..
</div>

<!-- Delete Template Confirmation Modal -->
<div class="import-modal-backdrop" *ngIf="showDeleteConfirmModal" (click)="closeDeleteConfirm()">
  <div class="import-modal-content delete-confirm-modal" (click)="$event.stopPropagation()">
    <div class="import-modal-header">
      <h2 class="import-modal-title">Delete Template</h2>
      <button type="button" class="import-modal-close-btn" (click)="closeDeleteConfirm()">
        <span>&times;</span>
      </button>
    </div>
    <div class="import-modal-body">
      <p class="delete-confirm-text">Are you sure you want to delete this template <strong>"{{ templateToDelete?.mealPlanName }}"</strong>?</p>
      <div class="delete-confirm-actions">
        <button type="button" class="btn btnCancelDelete btnLabel1" (click)="closeDeleteConfirm()">Cancel</button>
        <button type="button" class="btn btnConfirmDelete btnLabel" [disabled]="isDeleting" (click)="confirmDeleteTemplate()">
          {{ isDeleting ? 'Deleting...' : 'Confirm' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Delete Result Modal (shows API response message) -->
<div class="import-modal-backdrop" *ngIf="showDeleteResultModal" (click)="closeDeleteResultModal()">
  <div class="import-modal-content delete-result-modal" (click)="$event.stopPropagation()">
    <div class="import-modal-header">
      <h2 class="import-modal-title">{{ deleteResultError ? 'Error' : 'Template Deleted' }}</h2>
      <button type="button" class="import-modal-close-btn" (click)="closeDeleteResultModal()">
        <span>&times;</span>
      </button>
    </div>
    <div class="import-modal-body">
      <p class="delete-result-text">{{ deleteResultMessage }}</p>
      <div class="delete-confirm-actions">
        <button type="button" class="btn btnConfirmDelete btnLabel" (click)="closeDeleteResultModal()">OK</button>
      </div>
    </div>
  </div>
</div>

<!-- Import Success Modal -->
<div class="import-modal-backdrop" *ngIf="showImportSuccessModal" (click)="closeImportSuccessModal()">
  <div class="import-modal-content delete-result-modal" (click)="$event.stopPropagation()">
    <div class="import-modal-header">
      <h2 class="import-modal-title">Import Successful</h2>
      <button type="button" class="import-modal-close-btn" (click)="closeImportSuccessModal()">
        <span>&times;</span>
      </button>
    </div>
    <div class="import-modal-body">
      <p class="delete-confirm-text">You have imported the <strong>"{{ importSuccessTemplateName }}"</strong> to {{ importSuccessMemberNames.join(', ') }}.</p>
      <div class="delete-confirm-actions">
        <button type="button" class="btn btnConfirmDelete btnLabel" (click)="closeImportSuccessModal()">OK</button>
      </div>
    </div>
  </div>
</div>

<!-- Import Template Modal -->
<div class="import-modal-backdrop" *ngIf="showImportModal" (click)="closeImportModal()">
  <div class="import-modal-content" (click)="$event.stopPropagation()">
    <div class="import-modal-header">
      <h2 class="import-modal-title">Import Template To:</h2>
      <button type="button" class="import-modal-close-btn" (click)="closeImportModal()" [disabled]="isImportingTemplate">
        <span>&times;</span>
      </button>
    </div>

    <div class="import-modal-body import-modal-body-relative">
      <div class="import-template-loader-overlay" *ngIf="isImportingTemplate">
        <div class="import-template-spinner"></div>
        <p class="import-template-loader-text">Importing template...</p>
      </div>
      <div class="import-member-search-section">
        <div class="import-member-search-row">
          <input
            type="text"
            [(ngModel)]="memberSearchName"
            (input)="onMemberSearchChange()"
            class="import-member-search-input"
            placeholder="Search By Name"
          />
          <input
            type="text"
            [(ngModel)]="memberSearchEmail"
            (input)="onMemberSearchChange()"
            class="import-member-search-input"
            placeholder="Search By Email"
          />
          <button
            type="button"
            class="import-template-btn"
            [disabled]="selectedMemberIds.size === 0 || isImportingTemplate"
            (click)="onImportTemplate()"
          >
            {{ isImportingTemplate ? 'Importing...' : 'Import the Template' }}
          </button>
        </div>
      </div>

      <div class="import-loading-state" *ngIf="isLoadingMembers">
        <p>Loading members...</p>
      </div>

      <div class="import-members-table-container" *ngIf="!isLoadingMembers">
        <table class="import-members-table">
          <thead>
            <tr>
              <th></th>
              <th>Name</th>
              <th>Email</th>
              <th>Gender</th>
              <th>Age</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let member of filteredMembers">
              <td>
                <div class="import-member-checkbox-wrapper">
                  <input
                    type="checkbox"
                    [id]="'import-member-' + member.memberId"
                    [checked]="isMemberSelected(member.memberId)"
                    (click)="toggleMemberSelection(member.memberId)"
                    class="import-member-checkbox-input"
                  />
                  <label
                    [for]="'import-member-' + member.memberId"
                    class="import-member-checkbox-label"
                  >
                    <span class="import-member-checkmark"></span>
                  </label>
                </div>
              </td>
              <td>{{ member.name }}</td>
              <td>{{ member.email }}</td>
              <td>{{ member.gender }}</td>
              <td>{{ member.age }}</td>
            </tr>
          </tbody>
        </table>

        <div class="import-empty-members-state" *ngIf="filteredMembers.length === 0">
          <p>No members found matching your search criteria.</p>
        </div>
      </div>
    </div>
  </div>
</div>

